import { render } from "./MainPhanMem.vue?vue&type=template&id=1be723e8&scoped=true"
import script from "./MainPhanMem.vue?vue&type=script&lang=js"
export * from "./MainPhanMem.vue?vue&type=script&lang=js"

import "./MainPhanMem.vue?vue&type=style&index=0&id=1be723e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be723e8"]])

export default __exports__